import { ChatMarkdown } from '@/modules/common/Chat/components/ChatMarkdown';

interface DocumentChatMarkdownProps {
  markdown: string;
}

export function DocumentChatMarkdown({ markdown }: DocumentChatMarkdownProps) {
  return <ChatMarkdown markdown={markdown} />;
}
